module.exports = __webpack_public_path__ + "1f3c00b1ab25025a033c614118339b46.svg";